import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Box, Button, TableBody } from "@mui/material";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import { useMyPendingDiscounts } from "../../hooks/useMyPendingDiscounts";

export default function DiscountsCategoriesPendingByAdmin() {
    const { t } = useTranslation();
    function convertDate(dateString) {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // yyyy-mm-dd
    }
    const columns = [
        { id: "image Discount", label: t("Image Discount"), minWidth: 150 },
        { id: "title", label: t("title"), minWidth: 150 },
        { id: "description", label: t("description"), minWidth: 150 },
        { id: "discount Type", label: t("Discount Type"), minWidth: 150 },
        { id: "discount StartDate", label: t("discount StartDate"), minWidth: 150 },
        { id: "discount endDate", label: t("discount EndDate"), minWidth: 150 },
        { id: "Discount Percentage", label: t("Discount Percentage"), minWidth: 150 },
        { id: "amountBeforeDiscount", label: t("Amount Before Discount"), minWidth: 150 },
        { id: "amountAfterDiscount", label: t("Amount After Discount"), minWidth: 150 },
        { id: "actions", label: t("actions"), minWidth: 150 },
    ];

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { data, isLoading } = useMyPendingDiscounts();
    useEffect(() => {
        if (data?.data) {
            setCategoires(data.data);
        }
    }, [data]);

    const [categories, setCategoires] = useState([]);

    const { closeSnackbar, enqueueSnackbar } = useSnackbar();
    const lang = Cookies.get("i18next") || "en";

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };


    const handleAccept = async (id) => {
        closeSnackbar();
        try {
            await fetch(
                `${process.env.REACT_APP_API_KEY}api/v1/teacher/discounts/status/accept-discount/${id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                }
            );

            enqueueSnackbar(t("Activation process was successful."), { variant: "success", autoHideDuration: 8000 });
            filterTeachers(id)
        } catch (err) {
            enqueueSnackbar(t("Activation failed."), { variant: "error", autoHideDuration: 8000 });
        }
    };
    const handleReject = async (id) => {
        closeSnackbar();
        try {
            await fetch(
                `${process.env.REACT_APP_API_KEY}api/v1/teacher/discounts/delete-discount/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json"
                    },
                }
            );

            enqueueSnackbar(t("The discount offer has been declined."), { variant: "success", autoHideDuration: 8000 });
            filterTeachers(id)
        } catch (err) {
            enqueueSnackbar(t("An error occurred while declining the discount offer."), { variant: "error", autoHideDuration: 8000 });
        }
    };


    function filterTeachers(id) {
        const filteredTeachers = categories.filter(
            (teacher) => teacher.id.toString() !== id.toString()
        );
        setCategoires(filteredTeachers);
    }

    return (
        <Box>
            {!isLoading ? (
                <Paper sx={{ width: "100%", padding: "20px" }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={"center"}
                                        style={{ top: 57, minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableBody>
                                {categories
                                    ?.map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" key={row.id + "demj"}>
                                                <TableCell align="center">
                                                    <img src={row.image ? `${process.env.REACT_APP_API_KEY}images/${row.image}` : "/logo.png"} alt={row.image} width={"100px"} />
                                                </TableCell>
                                                {
                                                    lang === "ar" ?
                                                        <>
                                                            <TableCell align="center">{row.titleArabic}</TableCell>
                                                            <TableCell align="center">{row.descriptionArabic}</TableCell>
                                                            <TableCell align="center">{t(row.discountType)}</TableCell>
                                                            <TableCell align="center">{convertDate(row.discountStartDate)}</TableCell>
                                                            <TableCell align="center">{convertDate(row.discountEndDate)}</TableCell>
                                                            <TableCell align="center">{row.discountRate}</TableCell>
                                                            <TableCell align="center">{row.amountBeforeDiscount}</TableCell>

                                                            <TableCell align="center">{row.amountAfterDiscount}</TableCell>
                                                        </>
                                                        :
                                                        <>
                                                            <TableCell align="center">{row.titleEnglish}</TableCell>
                                                            <TableCell align="center">{row.descriptionEnglish}</TableCell>
                                                            <TableCell align="center">{t(row.discountType)}</TableCell>
                                                            <TableCell align="center">{row.discountStartDate}</TableCell>
                                                            <TableCell align="center">{row.discountEndDate}</TableCell>
                                                            <TableCell align="center">{row.discountRate}</TableCell>
                                                            <TableCell align="center">{row.amountBeforeDiscount}</TableCell>
                                                            <TableCell align="center">{row.amountAfterDiscount}</TableCell>
                                                        </>
                                                }
                                                <TableCell align="center">
                                                    <Button color="success">
                                                        <DoneIcon onClick={() => handleAccept(row.id)} />
                                                    </Button>
                                                    <Button
                                                        color="error"
                                                        onClick={() => handleReject(row.id)}
                                                    >
                                                        <ClearIcon />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={categories.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            ) : (
                <Loading />
            )}
        </Box>
    );
}

